module.exports = __webpack_public_path__ + "img/Cancel1.1a4ffe37.svg";